module.exports = __webpack_public_path__ + "img/CC-Logo.90641fdc.png";